export default __webpack_public_path__ + "static/media/appMessage.2022ff09.svg";